import React, { useEffect } from 'react';
import { login } from '../utils/auth';
import { SdfBusyIndicator } from '@waypoint/react-components';
import { CONFIG } from '../utils/config';

export const LoginPageComponent = () => {
  useEffect(() => {
    (async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('returnUrl') || urlParams.get('continue') || '';
        const plru = urlParams.get('plru') || CONFIG.POST_LOGIN_REDIRECT_URI;
        console.log('headless: Redirecting to login with plru:', plru, 'returnUrl:', returnUrl);
        await login(plru, returnUrl);
      } catch (err) {
        console.error('❌ Login failed:', err);
      }
    })();
  }, []);

  return <SdfBusyIndicator inverse fullscreen size="lg" />
};
